import _ from 'lodash'
import { Validator } from 'vee-validate'
import Config from '@/api/config'
import Payments from '@/api/services/payments'
import PhoneNumber from 'awesome-phonenumber'

const logInfo = !!(process.env.NODE_ENV !== 'production')

export default {
  data () {
    return {
      simulatedPayment: {
        chargeAmount: '',
        MSISDN: '',
        paymentOption: '',
        accountNumber: '',
        savePhoneNumber: false
      }
    }
  },
  methods: {
    attachCustomValidators () {
      Validator.extend('phone_number', {
        getMessage: field => `The phone number provided is not a valid phone number.`,
        validate: value => new Promise((resolve) => {
          let isPhoneNumberValid = PhoneNumber(`+${value}`).isValid()
          resolve({
            valid: isPhoneNumberValid
          })
        })
      })
    },
    cancelSimulator () {
      this.$modal.hide('simulate-payment')
      // Reset the user form
      this.simulatedPayment = {
        amount: '',
        paymentOption: '',
        accountNumber: ''
      }
    },
    launchSimulator () {
      // Prefill the mobile number with the user's number
      this.simulatedPayment.MSISDN = this.userInfo.MSISDN
      this.$modal.show('simulate-payment')
    },
    simulatePayment () {
      this.$validator.validateAll()
        .then(result => {
          logInfo && console.log('Did the simulate payment request pass validation?', result)
          // TODO: Implement a simulation of payments
          if (result) {
            Payments.simulatePayment({
              payment: {
                'countryCode': _.upperCase(this.simulatedPayment.paymentOption.countryCode),
                'accountNumber': this.simulatedPayment.accountNumber,
                'customerName': `${this.userInfo.firstName} ${this.userInfo.lastName}`,
                'MSISDN': this.simulatedPayment.MSISDN,
                'chargeAmount': this.simulatedPayment.chargeAmount,
                'currencyCode': Config.CURRENCIES[this.simulatedPayment.paymentOption.countryCode].code,
                'serviceCode': this.currentService.serviceCode,
                'narration': `Simulated payment by ${this.userInfo.firstName} ${this.userInfo.lastName}`,
                'payerClientCode': this.simulatedPayment.paymentOption.key
              }
            })
              .then(response => {
                logInfo && console.log('Successfully simulated a payment', response)
                this.cancelSimulator()
                this.$snackbar.open({
                  message: `Payment successfully made`,
                  type: 'is-success',
                  position: 'is-bottom',
                  queue: false
                })
              })
              .catch(reason => {
                logInfo && console.log('Failed to invite a user', reason)
                this.cancelSimulator()
                if (reason.STATCODE === 7) {
                  this.$snackbar.open({
                    message: `Simulating the payment failed`,
                    type: 'is-error',
                    position: 'is-bottom',
                    queue: false,
                    actionText: 'RETRY',
                    onAction: () => {
                      this.simulatePayment()
                    }
                  })
                } else {
                  this.$snackbar.open({
                    message: _.capitalize(reason.REASON),
                    type: 'is-warning',
                    position: 'is-bottom',
                    queue: false,
                    actionText: 'OK'
                  })
                }
              })
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/PaymentSimulator.js